module.exports = __webpack_public_path__ + "img/GAME_GETTHENUMBERDISH2.ea8eaa70.jpg";